import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-shield-check-line text-lg"></i>
              </span>
              <span className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">安全资讯中心</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于为用户提供全面的网络安全资讯，帮助识别虚假页面、恶意下载和隐私风险。访问前请确认来源可靠，遵守当地法律法规。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-categories" className="hover:text-primary-600 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-links" className="hover:text-primary-600 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <Link to="/category/safety-tips" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">安全提示</Link>
              </li>
              <li>
                <Link to="/category/faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">常见问题</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-disclaimer" className="hover:text-primary-600 transition-colors">免责声明</a>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              本站所有内容仅供信息参考和教育目的。我们不提供、不推荐、不链接任何违法违规内容。请用户自行遵守所在地区的法律法规，本站不对用户的任何行为承担责任。
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between mt-10 pt-6 border-t border-background-200/70 gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 安全资讯中心. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">使用条款</a>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}